/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * This file is generated by packages/server/scripts/generate-permissions.ts
 * Run `pnpm generate:permissions` from packages/server to regenerate.
 *
 * Source of truth: SERVER_ROUTES in @mastra/server
 */

/**
 * All known API resources.
 * Derived from SERVER_ROUTES paths in @mastra/server.
 */
export const RESOURCES = [
  'a2a',
  'agent-builder',
  'agents',
  'auth',
  'background-tasks',
  'channels',
  'datasets',
  'embedders',
  'experiments',
  'infrastructure',
  'logs',
  'mcp',
  'memory',
  'observability',
  'processor-providers',
  'processors',
  'schedules',
  'scores',
  'stored-agents',
  'stored-mcp-clients',
  'stored-prompt-blocks',
  'stored-scorers',
  'stored-skills',
  'stored-workspaces',
  'system',
  'tool-providers',
  'tools',
  'vector',
  'vectors',
  'workflows',
  'workspaces',
] as const;

/**
 * Resource type union.
 */
export type Resource = (typeof RESOURCES)[number];

/**
 * All permission actions.
 * Derived from HTTP methods and route overrides:
 * - GET → read
 * - POST → write or execute (context-dependent)
 * - PUT/PATCH → write
 * - DELETE → delete
 * - Additional actions from explicit requiresPermission overrides
 */
export const ACTIONS = ['create', 'delete', 'execute', 'publish', 'read', 'share', 'write'] as const;

/**
 * Action type union.
 */
export type Action = (typeof ACTIONS)[number];

/**
 * All valid permission patterns.
 * Use `keyof typeof PERMISSION_PATTERNS` or the `PermissionPattern` type.
 */
export const PERMISSION_PATTERNS = {
  /** Full access to all resources and actions */
  '*': '*',
  /** Create all resources */
  '*:create': '*:create',
  /** Delete all resources */
  '*:delete': '*:delete',
  /** Execute all resources */
  '*:execute': '*:execute',
  /** Publish, activate, or restore all resources */
  '*:publish': '*:publish',
  /** View all resources */
  '*:read': '*:read',
  /** Change visibility/audience all resources */
  '*:share': '*:share',
  /** Create and modify all resources */
  '*:write': '*:write',
  /** Full access to agent-to-agent communication */
  'a2a:*': 'a2a:*',
  /** Full access to agent builder */
  'agent-builder:*': 'agent-builder:*',
  /** Full access to agents */
  'agents:*': 'agents:*',
  /** Full access to auth */
  'auth:*': 'auth:*',
  /** Full access to background tasks */
  'background-tasks:*': 'background-tasks:*',
  /** Full access to channels */
  'channels:*': 'channels:*',
  /** Full access to datasets */
  'datasets:*': 'datasets:*',
  /** Full access to embedders */
  'embedders:*': 'embedders:*',
  /** Full access to experiments */
  'experiments:*': 'experiments:*',
  /** Full access to infrastructure */
  'infrastructure:*': 'infrastructure:*',
  /** Full access to logs */
  'logs:*': 'logs:*',
  /** Full access to MCP servers */
  'mcp:*': 'mcp:*',
  /** Full access to memory and threads */
  'memory:*': 'memory:*',
  /** Full access to traces and spans */
  'observability:*': 'observability:*',
  /** Full access to processor-providers */
  'processor-providers:*': 'processor-providers:*',
  /** Full access to processors */
  'processors:*': 'processors:*',
  /** Full access to schedules */
  'schedules:*': 'schedules:*',
  /** Full access to evaluation scores */
  'scores:*': 'scores:*',
  /** Full access to stored agents */
  'stored-agents:*': 'stored-agents:*',
  /** Full access to stored MCP clients */
  'stored-mcp-clients:*': 'stored-mcp-clients:*',
  /** Full access to stored prompt blocks */
  'stored-prompt-blocks:*': 'stored-prompt-blocks:*',
  /** Full access to stored scorers */
  'stored-scorers:*': 'stored-scorers:*',
  /** Full access to stored skills */
  'stored-skills:*': 'stored-skills:*',
  /** Full access to stored workspaces */
  'stored-workspaces:*': 'stored-workspaces:*',
  /** Full access to system info */
  'system:*': 'system:*',
  /** Full access to tool-providers */
  'tool-providers:*': 'tool-providers:*',
  /** Full access to tools */
  'tools:*': 'tools:*',
  /** Full access to vector stores */
  'vector:*': 'vector:*',
  /** Full access to vectors */
  'vectors:*': 'vectors:*',
  /** Full access to workflows */
  'workflows:*': 'workflows:*',
  /** Full access to workspaces */
  'workspaces:*': 'workspaces:*',
  /** View agent-to-agent communication */
  'a2a:read': 'a2a:read',
  /** Create and modify agent-to-agent communication */
  'a2a:write': 'a2a:write',
  /** Execute agent builder */
  'agent-builder:execute': 'agent-builder:execute',
  /** View agent builder */
  'agent-builder:read': 'agent-builder:read',
  /** Create and modify agent builder */
  'agent-builder:write': 'agent-builder:write',
  /** Create agents */
  'agents:create': 'agents:create',
  /** Delete agents */
  'agents:delete': 'agents:delete',
  /** Execute agents */
  'agents:execute': 'agents:execute',
  /** View agents */
  'agents:read': 'agents:read',
  /** Create and modify agents */
  'agents:write': 'agents:write',
  /** View auth */
  'auth:read': 'auth:read',
  /** View background tasks */
  'background-tasks:read': 'background-tasks:read',
  /** View channels */
  'channels:read': 'channels:read',
  /** Create and modify channels */
  'channels:write': 'channels:write',
  /** Delete datasets */
  'datasets:delete': 'datasets:delete',
  /** Execute datasets */
  'datasets:execute': 'datasets:execute',
  /** View datasets */
  'datasets:read': 'datasets:read',
  /** Create and modify datasets */
  'datasets:write': 'datasets:write',
  /** View embedders */
  'embedders:read': 'embedders:read',
  /** View experiments */
  'experiments:read': 'experiments:read',
  /** View infrastructure */
  'infrastructure:read': 'infrastructure:read',
  /** View logs */
  'logs:read': 'logs:read',
  /** Execute MCP servers */
  'mcp:execute': 'mcp:execute',
  /** View MCP servers */
  'mcp:read': 'mcp:read',
  /** Create and modify MCP servers */
  'mcp:write': 'mcp:write',
  /** Delete memory and threads */
  'memory:delete': 'memory:delete',
  /** Execute memory and threads */
  'memory:execute': 'memory:execute',
  /** View memory and threads */
  'memory:read': 'memory:read',
  /** Create and modify memory and threads */
  'memory:write': 'memory:write',
  /** View traces and spans */
  'observability:read': 'observability:read',
  /** Create and modify traces and spans */
  'observability:write': 'observability:write',
  /** View processor-providers */
  'processor-providers:read': 'processor-providers:read',
  /** Execute processors */
  'processors:execute': 'processors:execute',
  /** View processors */
  'processors:read': 'processors:read',
  /** Execute schedules */
  'schedules:execute': 'schedules:execute',
  /** View schedules */
  'schedules:read': 'schedules:read',
  /** Create and modify schedules */
  'schedules:write': 'schedules:write',
  /** View evaluation scores */
  'scores:read': 'scores:read',
  /** Create and modify evaluation scores */
  'scores:write': 'scores:write',
  /** Delete stored agents */
  'stored-agents:delete': 'stored-agents:delete',
  /** Publish, activate, or restore stored agents */
  'stored-agents:publish': 'stored-agents:publish',
  /** View stored agents */
  'stored-agents:read': 'stored-agents:read',
  /** Create and modify stored agents */
  'stored-agents:write': 'stored-agents:write',
  /** Delete stored MCP clients */
  'stored-mcp-clients:delete': 'stored-mcp-clients:delete',
  /** Publish, activate, or restore stored MCP clients */
  'stored-mcp-clients:publish': 'stored-mcp-clients:publish',
  /** View stored MCP clients */
  'stored-mcp-clients:read': 'stored-mcp-clients:read',
  /** Create and modify stored MCP clients */
  'stored-mcp-clients:write': 'stored-mcp-clients:write',
  /** Delete stored prompt blocks */
  'stored-prompt-blocks:delete': 'stored-prompt-blocks:delete',
  /** Publish, activate, or restore stored prompt blocks */
  'stored-prompt-blocks:publish': 'stored-prompt-blocks:publish',
  /** View stored prompt blocks */
  'stored-prompt-blocks:read': 'stored-prompt-blocks:read',
  /** Create and modify stored prompt blocks */
  'stored-prompt-blocks:write': 'stored-prompt-blocks:write',
  /** Delete stored scorers */
  'stored-scorers:delete': 'stored-scorers:delete',
  /** Publish, activate, or restore stored scorers */
  'stored-scorers:publish': 'stored-scorers:publish',
  /** View stored scorers */
  'stored-scorers:read': 'stored-scorers:read',
  /** Create and modify stored scorers */
  'stored-scorers:write': 'stored-scorers:write',
  /** Delete stored skills */
  'stored-skills:delete': 'stored-skills:delete',
  /** Publish, activate, or restore stored skills */
  'stored-skills:publish': 'stored-skills:publish',
  /** View stored skills */
  'stored-skills:read': 'stored-skills:read',
  /** Create and modify stored skills */
  'stored-skills:write': 'stored-skills:write',
  /** Delete stored workspaces */
  'stored-workspaces:delete': 'stored-workspaces:delete',
  /** View stored workspaces */
  'stored-workspaces:read': 'stored-workspaces:read',
  /** Create and modify stored workspaces */
  'stored-workspaces:write': 'stored-workspaces:write',
  /** View system info */
  'system:read': 'system:read',
  /** Delete tool-providers */
  'tool-providers:delete': 'tool-providers:delete',
  /** View tool-providers */
  'tool-providers:read': 'tool-providers:read',
  /** Create and modify tool-providers */
  'tool-providers:write': 'tool-providers:write',
  /** Execute tools */
  'tools:execute': 'tools:execute',
  /** View tools */
  'tools:read': 'tools:read',
  /** Delete vector stores */
  'vector:delete': 'vector:delete',
  /** Execute vector stores */
  'vector:execute': 'vector:execute',
  /** View vector stores */
  'vector:read': 'vector:read',
  /** Create and modify vector stores */
  'vector:write': 'vector:write',
  /** View vectors */
  'vectors:read': 'vectors:read',
  /** Delete workflows */
  'workflows:delete': 'workflows:delete',
  /** Execute workflows */
  'workflows:execute': 'workflows:execute',
  /** View workflows */
  'workflows:read': 'workflows:read',
  /** Create and modify workflows */
  'workflows:write': 'workflows:write',
  /** Delete workspaces */
  'workspaces:delete': 'workspaces:delete',
  /** View workspaces */
  'workspaces:read': 'workspaces:read',
  /** Create and modify workspaces */
  'workspaces:write': 'workspaces:write',
  /** Full access to all stored resource families */
  'stored:*': 'stored:*',
  /** View all stored resource families */
  'stored:read': 'stored:read',
  /** Create and modify all stored resource families */
  'stored:write': 'stored:write',
  /** Delete all stored resource families */
  'stored:delete': 'stored:delete',
  /** Change visibility/audience stored agents */
  'stored-agents:share': 'stored-agents:share',
  /** Change visibility/audience stored skills */
  'stored-skills:share': 'stored-skills:share',
} as const;

/**
 * Permission pattern that can be used in role definitions.
 * Supports:
 * - Specific permissions: 'agents:read', 'workflows:execute'
 * - Resource wildcards: 'agents:*', 'workflows:*' (all actions on a resource)
 * - Action wildcards: '*:read', '*:write' (an action across all resources)
 * - Global wildcard: '*' (full access)
 */
export type PermissionPattern = keyof typeof PERMISSION_PATTERNS;

/**
 * All valid resource:action permission combinations (excludes wildcards).
 */
export const PERMISSIONS = [
  'a2a:read',
  'a2a:write',
  'agent-builder:execute',
  'agent-builder:read',
  'agent-builder:write',
  'agents:create',
  'agents:delete',
  'agents:execute',
  'agents:read',
  'agents:write',
  'auth:read',
  'background-tasks:read',
  'channels:read',
  'channels:write',
  'datasets:delete',
  'datasets:execute',
  'datasets:read',
  'datasets:write',
  'embedders:read',
  'experiments:read',
  'infrastructure:read',
  'logs:read',
  'mcp:execute',
  'mcp:read',
  'mcp:write',
  'memory:delete',
  'memory:execute',
  'memory:read',
  'memory:write',
  'observability:read',
  'observability:write',
  'processor-providers:read',
  'processors:execute',
  'processors:read',
  'schedules:execute',
  'schedules:read',
  'schedules:write',
  'scores:read',
  'scores:write',
  'stored-agents:delete',
  'stored-agents:publish',
  'stored-agents:read',
  'stored-agents:write',
  'stored-mcp-clients:delete',
  'stored-mcp-clients:publish',
  'stored-mcp-clients:read',
  'stored-mcp-clients:write',
  'stored-prompt-blocks:delete',
  'stored-prompt-blocks:publish',
  'stored-prompt-blocks:read',
  'stored-prompt-blocks:write',
  'stored-scorers:delete',
  'stored-scorers:publish',
  'stored-scorers:read',
  'stored-scorers:write',
  'stored-skills:delete',
  'stored-skills:publish',
  'stored-skills:read',
  'stored-skills:write',
  'stored-workspaces:delete',
  'stored-workspaces:read',
  'stored-workspaces:write',
  'system:read',
  'tool-providers:delete',
  'tool-providers:read',
  'tool-providers:write',
  'tools:execute',
  'tools:read',
  'vector:delete',
  'vector:execute',
  'vector:read',
  'vector:write',
  'vectors:read',
  'workflows:delete',
  'workflows:execute',
  'workflows:read',
  'workflows:write',
  'workspaces:delete',
  'workspaces:read',
  'workspaces:write',
] as const;

/**
 * Specific permission type (e.g., 'agents:read', 'workflows:execute').
 */
export type Permission = (typeof PERMISSIONS)[number];

/**
 * Type-safe constants for Mastra-owned FGA permissions.
 *
 * These values are generated from server routes and can be used wherever
 * Mastra checks or maps FGA permissions.
 */
export const MastraFGAPermissions = {
  /** View agent-to-agent communication */
  A2A_READ: 'a2a:read',
  /** Create and modify agent-to-agent communication */
  A2A_WRITE: 'a2a:write',
  /** Execute agent builder */
  AGENT_BUILDER_EXECUTE: 'agent-builder:execute',
  /** View agent builder */
  AGENT_BUILDER_READ: 'agent-builder:read',
  /** Create and modify agent builder */
  AGENT_BUILDER_WRITE: 'agent-builder:write',
  /** Create agents */
  AGENTS_CREATE: 'agents:create',
  /** Delete agents */
  AGENTS_DELETE: 'agents:delete',
  /** Execute agents */
  AGENTS_EXECUTE: 'agents:execute',
  /** View agents */
  AGENTS_READ: 'agents:read',
  /** Create and modify agents */
  AGENTS_WRITE: 'agents:write',
  /** View auth */
  AUTH_READ: 'auth:read',
  /** View background tasks */
  BACKGROUND_TASKS_READ: 'background-tasks:read',
  /** View channels */
  CHANNELS_READ: 'channels:read',
  /** Create and modify channels */
  CHANNELS_WRITE: 'channels:write',
  /** Delete datasets */
  DATASETS_DELETE: 'datasets:delete',
  /** Execute datasets */
  DATASETS_EXECUTE: 'datasets:execute',
  /** View datasets */
  DATASETS_READ: 'datasets:read',
  /** Create and modify datasets */
  DATASETS_WRITE: 'datasets:write',
  /** View embedders */
  EMBEDDERS_READ: 'embedders:read',
  /** View experiments */
  EXPERIMENTS_READ: 'experiments:read',
  /** View infrastructure */
  INFRASTRUCTURE_READ: 'infrastructure:read',
  /** View logs */
  LOGS_READ: 'logs:read',
  /** Execute MCP servers */
  MCP_EXECUTE: 'mcp:execute',
  /** View MCP servers */
  MCP_READ: 'mcp:read',
  /** Create and modify MCP servers */
  MCP_WRITE: 'mcp:write',
  /** Delete memory and threads */
  MEMORY_DELETE: 'memory:delete',
  /** Execute memory and threads */
  MEMORY_EXECUTE: 'memory:execute',
  /** View memory and threads */
  MEMORY_READ: 'memory:read',
  /** Create and modify memory and threads */
  MEMORY_WRITE: 'memory:write',
  /** View traces and spans */
  OBSERVABILITY_READ: 'observability:read',
  /** Create and modify traces and spans */
  OBSERVABILITY_WRITE: 'observability:write',
  /** View processor-providers */
  PROCESSOR_PROVIDERS_READ: 'processor-providers:read',
  /** Execute processors */
  PROCESSORS_EXECUTE: 'processors:execute',
  /** View processors */
  PROCESSORS_READ: 'processors:read',
  /** Execute schedules */
  SCHEDULES_EXECUTE: 'schedules:execute',
  /** View schedules */
  SCHEDULES_READ: 'schedules:read',
  /** Create and modify schedules */
  SCHEDULES_WRITE: 'schedules:write',
  /** View evaluation scores */
  SCORES_READ: 'scores:read',
  /** Create and modify evaluation scores */
  SCORES_WRITE: 'scores:write',
  /** Delete stored agents */
  STORED_AGENTS_DELETE: 'stored-agents:delete',
  /** Publish, activate, or restore stored agents */
  STORED_AGENTS_PUBLISH: 'stored-agents:publish',
  /** View stored agents */
  STORED_AGENTS_READ: 'stored-agents:read',
  /** Create and modify stored agents */
  STORED_AGENTS_WRITE: 'stored-agents:write',
  /** Delete stored MCP clients */
  STORED_MCP_CLIENTS_DELETE: 'stored-mcp-clients:delete',
  /** Publish, activate, or restore stored MCP clients */
  STORED_MCP_CLIENTS_PUBLISH: 'stored-mcp-clients:publish',
  /** View stored MCP clients */
  STORED_MCP_CLIENTS_READ: 'stored-mcp-clients:read',
  /** Create and modify stored MCP clients */
  STORED_MCP_CLIENTS_WRITE: 'stored-mcp-clients:write',
  /** Delete stored prompt blocks */
  STORED_PROMPT_BLOCKS_DELETE: 'stored-prompt-blocks:delete',
  /** Publish, activate, or restore stored prompt blocks */
  STORED_PROMPT_BLOCKS_PUBLISH: 'stored-prompt-blocks:publish',
  /** View stored prompt blocks */
  STORED_PROMPT_BLOCKS_READ: 'stored-prompt-blocks:read',
  /** Create and modify stored prompt blocks */
  STORED_PROMPT_BLOCKS_WRITE: 'stored-prompt-blocks:write',
  /** Delete stored scorers */
  STORED_SCORERS_DELETE: 'stored-scorers:delete',
  /** Publish, activate, or restore stored scorers */
  STORED_SCORERS_PUBLISH: 'stored-scorers:publish',
  /** View stored scorers */
  STORED_SCORERS_READ: 'stored-scorers:read',
  /** Create and modify stored scorers */
  STORED_SCORERS_WRITE: 'stored-scorers:write',
  /** Delete stored skills */
  STORED_SKILLS_DELETE: 'stored-skills:delete',
  /** Publish, activate, or restore stored skills */
  STORED_SKILLS_PUBLISH: 'stored-skills:publish',
  /** View stored skills */
  STORED_SKILLS_READ: 'stored-skills:read',
  /** Create and modify stored skills */
  STORED_SKILLS_WRITE: 'stored-skills:write',
  /** Delete stored workspaces */
  STORED_WORKSPACES_DELETE: 'stored-workspaces:delete',
  /** View stored workspaces */
  STORED_WORKSPACES_READ: 'stored-workspaces:read',
  /** Create and modify stored workspaces */
  STORED_WORKSPACES_WRITE: 'stored-workspaces:write',
  /** View system info */
  SYSTEM_READ: 'system:read',
  /** Delete tool-providers */
  TOOL_PROVIDERS_DELETE: 'tool-providers:delete',
  /** View tool-providers */
  TOOL_PROVIDERS_READ: 'tool-providers:read',
  /** Create and modify tool-providers */
  TOOL_PROVIDERS_WRITE: 'tool-providers:write',
  /** Execute tools */
  TOOLS_EXECUTE: 'tools:execute',
  /** View tools */
  TOOLS_READ: 'tools:read',
  /** Delete vector stores */
  VECTOR_DELETE: 'vector:delete',
  /** Execute vector stores */
  VECTOR_EXECUTE: 'vector:execute',
  /** View vector stores */
  VECTOR_READ: 'vector:read',
  /** Create and modify vector stores */
  VECTOR_WRITE: 'vector:write',
  /** View vectors */
  VECTORS_READ: 'vectors:read',
  /** Delete workflows */
  WORKFLOWS_DELETE: 'workflows:delete',
  /** Execute workflows */
  WORKFLOWS_EXECUTE: 'workflows:execute',
  /** View workflows */
  WORKFLOWS_READ: 'workflows:read',
  /** Create and modify workflows */
  WORKFLOWS_WRITE: 'workflows:write',
  /** Delete workspaces */
  WORKSPACES_DELETE: 'workspaces:delete',
  /** View workspaces */
  WORKSPACES_READ: 'workspaces:read',
  /** Create and modify workspaces */
  WORKSPACES_WRITE: 'workspaces:write',
} as const satisfies Record<string, Permission>;

/**
 * Mastra-owned FGA permission values.
 */
export type MastraFGAPermission = (typeof MastraFGAPermissions)[keyof typeof MastraFGAPermissions];

/**
 * FGA permission input accepted by public config and provider APIs.
 * Keeps autocomplete for Mastra-owned permissions while allowing custom provider strings.
 */
export type MastraFGAPermissionInput = MastraFGAPermission | (string & {});

/**
 * Type-safe role mapping configuration.
 *
 * Maps role names (from your identity provider) to Mastra permission patterns.
 *
 * @example
 * ```typescript
 * const roleMapping: TypedRoleMapping = {
 *   "Engineering": ["agents:*", "workflows:*"],
 *   "Product": ["agents:read", "workflows:read"],
 *   "Admin": ["*"],
 *   "_default": [],
 * };
 * ```
 */
export type TypedRoleMapping = {
  [role: string]: PermissionPattern[];
};

/**
 * Validates that a string is a valid permission pattern.
 * Useful for runtime validation of permission strings.
 */
export function isValidPermissionPattern(pattern: string): pattern is PermissionPattern {
  return pattern in PERMISSION_PATTERNS;
}

/**
 * Validates that all permissions in an array are valid patterns.
 */
export function validatePermissions(permissions: string[]): permissions is PermissionPattern[] {
  return permissions.every(isValidPermissionPattern);
}
